import React from "react";
import moment from "moment";
import CustomShowModal from "../../../components/Common/CustomShowModal";

const formatCapitalize = (str) => {
  if (!str) return "";
  return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
};

const formatDisplayDate = (val) => {
  if (!val || val === "-") return "-";
  const m = moment(val, [
    "DD/MM/YYYY HH:mm",
    "DD/MM/YYYY",
    "YYYY-MM-DD HH:mm:ss.S",
    "YYYY-MM-DD HH:mm:ss",
    "YYYY-MM-DD HH:mm",
    "YYYY-MM-DDTHH:mm:ss.SSSZ",
    "YYYY-MM-DDTHH:mm:ssZ",
    "YYYY-MM-DD",
    moment.ISO_8601,
  ]);
  if (m.isValid()) {
    if (typeof val === "string" && val.length === 10 && val.includes("-")) {
      return m.format("DD/MM/YYYY");
    }
    return m.format("DD/MM/YYYY HH:mm");
  }
  return val;
};

export const PortSelectInvoiceModal = ({
  open,
  handleClose,
  cargoList = [],
  onSelectPort,
  freightMode = "",
}) => {
  const isSingleFreight = freightMode?.toLowerCase() === "single freight";
  const firstLoadingIndex = isSingleFreight
    ? cargoList.findIndex((item) => (item.operation || "").toLowerCase() === "loading")
    : -1;

  return (
    <CustomShowModal
      open={open}
      handleClose={handleClose}
      maxWidth="sm"
      title="Select Port to Issue Invoice"
    >
      <div className="p-1.5 bg-white">
        <p className="text-[11px] text-slate-600 mb-1.5 font-medium">
          Select a port operation from the list below to generate port-wise invoices and line items.
        </p>

        {cargoList.length === 0 ? (
          <div className="text-center py-4 bg-slate-50 border border-[#cbd5e1] text-slate-500 text-[11px] font-medium">
            No ports found in current operation calculation.
          </div>
        ) : (
          <div className="overflow-x-auto border border-[#cbd5e1]">
            <table className="w-full border-collapse text-left text-[11px] font-medium">
              <thead>
                <tr className="bg-[#dbe3ea] text-[#1e293b] font-medium h-[22px] border-b border-[#cbd5e1]">
                  <th className="px-1.5 py-0.5 border-r border-[#cbd5e1] w-[30px] text-center font-medium">#</th>
                  <th className="px-2 py-0.5 border-r border-[#cbd5e1] w-[90px] font-medium">Operation</th>
                  <th className="px-2 py-0.5 border-r border-[#cbd5e1] font-medium">Port Name</th>
                  <th className="px-2 py-0.5 border-r border-[#cbd5e1] w-[95px] text-right font-medium">Cargo Qty (MT)</th>
                  <th className="px-2 py-0.5 border-r border-[#cbd5e1] w-[125px] font-medium whitespace-nowrap">B/L Date</th>
                  <th className="px-2 py-0.5 text-center w-[100px] font-medium">Action</th>
                </tr>
              </thead>
              <tbody className="divide-y-0">
                {cargoList.map((portItem, index) => {
                  const portName = portItem.port || `Port ${index + 1}`;
                  const rawOp = portItem.operation || "Port Stay";
                  const opType = formatCapitalize(rawOp);
                  const isOpLoading = rawOp.toLowerCase() === "loading";
                  const isAvailable = isOpLoading && (!isSingleFreight || index === firstLoadingIndex);
                  const cargoQty = portItem.cargoQty ?? 0;
                  const rawDate = portItem.billOfLadingDate;
                  const blDate = rawDate ? formatDisplayDate(rawDate) : "-";

                  return (
                    <tr
                      key={index}
                      className={`h-[21px] transition-colors bg-white group ${
                        isAvailable ? "hover:bg-amber-50/60 cursor-pointer" : ""
                      }`}
                      onClick={() => {
                        if (isAvailable) {
                          onSelectPort(portItem, index);
                        }
                      }}
                    >
                      <td className="px-1.5 py-0 border-r border-b border-[#cbd5e1] text-center text-slate-600 h-[21px] align-middle text-[11px] font-medium">
                        {index + 1}
                      </td>
                      <td className="px-2 py-0 border-r border-b border-[#cbd5e1] h-[21px] align-middle text-[11px] text-slate-800 font-medium">
                        {opType}
                      </td>
                      <td className="px-2 py-0 border-r border-b border-[#cbd5e1] font-medium text-slate-900 h-[21px] align-middle text-[11px]">
                        {portName}
                      </td>
                      <td className="px-2 py-0 border-r border-b border-[#cbd5e1] text-right tabular-nums text-slate-800 h-[21px] align-middle text-[11px] font-medium">
                        {typeof cargoQty === "number" ? cargoQty.toLocaleString() : cargoQty}
                      </td>
                      <td className="px-2 py-0 border-r border-b border-[#cbd5e1] text-slate-700 h-[21px] align-middle text-[11px] font-medium whitespace-nowrap">
                        {blDate}
                      </td>
                      <td className="px-1 py-0 border-b border-[#cbd5e1] text-center h-[21px] align-middle">
                        {isAvailable ? (
                          <button
                            type="button"
                            onClick={(e) => {
                              e.stopPropagation();
                              onSelectPort(portItem, index);
                            }}
                            className="text-[11px] font-medium text-slate-900 underline hover:text-black transition-colors cursor-pointer bg-transparent border-none p-0 outline-none whitespace-nowrap inline-block"
                          >
                            Issue Invoice
                          </button>
                        ) : null}
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </CustomShowModal>
  );
};

export default PortSelectInvoiceModal;
